import React from "react";
import type { GameState } from "../../shared/types";

import Overlay from "./Overlay";

export default function Paused({ gameState }: { gameState: any }) {
  return (
    <Overlay gameState={gameState} className="canvas-overlay-faded-bg canvas-overlay-text">
      <h1>GAME PAUSED</h1>
    </Overlay>
  );
}
